const SplitTestConstants = {
  ZRM_AI_LISTING_CREATION_FLOW: 'zrm_ai_listing_creation_flow',
} as const;

export default SplitTestConstants;
